import { SxProps, Theme } from "@mui/material";
import { allowedTLDs, nameRegex } from "@src/shared/const";
import * as yup from "yup";



const emailTLDCheck = (value: string | undefined) => {
  if (!value) return false;

  const domain = value.split("@")[1];
  if (!domain) return false;

  const domainParts = domain.split(".");
  if (domainParts.length !== 2) return false;

  const tld = domainParts[1].toLowerCase();
  return allowedTLDs.includes(tld);
};

export const updateUserSchema = yup.object({
  last_name: yup
    .string()
    .required("Фамилия обязательна")
    .min(2, "Минимум 2 символа")
    .max(30, "Максимум 30 символов")
    .matches(
      nameRegex,
      "Фамилия может содержать только буквы, пробелы или дефисы"
    ),
  first_name: yup
    .string()
    .required("Имя обязательно")
    .min(2, "Минимум 2 символа")
    .max(30, "Максимум 30 символов")
    .matches(nameRegex, "Имя может содержать только буквы, пробелы или дефисы"),
  middle_name: yup
    .string()
    .transform((value) => (value?.trim() === "" ? undefined : value))
    .optional()
    .min(2, "Минимум 2 символа")
    .max(30, "Максимум 30 символов")
    .matches(
      nameRegex,
      "Отчество может содержать только буквы, пробелы или дефисы"
    ),

  email: yup
    .string()
    .required("Почта обязательна")
    .email("Неверный формат email")
    .test("valid-tld", "Недопустимая доменная зона", emailTLDCheck),
  phone: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .optional()
    .matches(/^\d{10,15}$/, "Неверный формат номера"),
});

export type UpdateUserFormValues = yup.InferType<typeof updateUserSchema>;

export const saveBtnStyles: SxProps<Theme> = {
  padding: "10px 32px",
  borderRadius: "10px",
  color: "white",
  fontWeight: 600,
  transition: "background 0.3s",
  margin: "10px",
  background: "#1FA1E5",
  "&:disabled": {
    background: "#cccccc",
    color: "#666666",
  },
};
